import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

const SchoolsTable = ({
    schools,
    isLoaded,
    toRemove,
    onAction,
    searchKey,
    countries,
    t,
}) => {
    if (!isLoaded) {
        return (
            <div className="users-table-wrapper">
                <div className="users-empty-state">
                    <div className="users-empty-icon text-danger">
                        <i className="fad fa-sync-alt fa-spin"></i>
                    </div>
                    <div className="users-empty-title">{t("Pages.SchoolsControl.Loading")}</div>
                </div>
            </div>
        );
    }

    const filterSchools = schools.filter((v) =>
        v.Name.toLowerCase().includes(searchKey.toLowerCase())
    );

    if (filterSchools.length === 0) {
        return (
            <div className="users-table-wrapper">
                <div className="users-empty-state">
                    <div className="users-empty-icon text-danger">
                        <i className="fad fa-telescope"></i>
                    </div>
                    <div className="users-empty-title">
                        {searchKey
                            ? `${t("Pages.SchoolsControl.NotFound")} "${searchKey}"`
                            : t("Pages.SchoolsControl.NotFound")}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="users-table-wrapper">
            {/* Desktop Table */}
            <div className="users-table-scroll d-none d-md-block">
                <table className="users-table">
                    <thead>
                        <tr className="text-right">
                            <th>
                                <i className="fad fa-school ml-2 text-primary"></i>
                                {t("Pages.Register.School.Name.title") || "اسم المدرسة"}
                            </th>
                            <th>
                                <i className="fad fa-address-card ml-2 text-primary"></i>
                                {t("Pages.UsersControl.tableHeaders.contact") || "معلومات الاتصال"}
                            </th>
                            <th className="text-center">
                                <i className="fad fa-info-circle ml-2 text-primary"></i>
                                {t("Pages.SchoolsControl.tableHeaders.info")}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {filterSchools.map((school) => {
                            const isQueuedForRemoval = toRemove && toRemove.includes(school.Id);
                            if (isQueuedForRemoval) return null;
                            return (
                                <tr
                                    key={school.Id}
                                    className="user-row align-middle text-right clickable-row"
                                    onClick={() => onAction("info", school, t)}
                                    style={{ cursor: "pointer" }}
                                >
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <div className="user-avatar-wrapper position-relative">
                                                <LazyLoadImage
                                                    src="/assets/images/logo/130p150.png"
                                                    alt={school.Name}
                                                    className="user-avatar-img border-active"
                                                />
                                                {school.IsLocked && (
                                                    <span
                                                        className="position-absolute d-flex align-items-center justify-content-center bg-dark text-white rounded-circle shadow-sm user-avatar-badge-bottom"
                                                        title={t("Pages.UsersControl.IsLocked")}
                                                    >
                                                        <i className="fas fa-lock"></i>
                                                    </span>
                                                )}
                                            </div>
                                            <div className="d-flex flex-column text-right">
                                                <span className="font-weight-bold text-dark user-name-btn-styled">
                                                    {school.Name}
                                                </span>
                                                <span className="text-muted small mt-1">
                                                    {school.Code ? `#${school.Code}` : ""}
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="d-flex flex-column text-right">
                                            {school.Email ? (
                                                <span className="contact-link">
                                                    <i className="fal fa-envelope-open-text ml-1"></i>
                                                    <span>{school.Email}</span>
                                                </span>
                                            ) : (
                                                <span className="text-muted small">-</span>
                                            )}
                                            {school.Phone ? (
                                                <span className="contact-link mt-1">
                                                    <i className="fal fa-phone-alt ml-1"></i>
                                                    <span>{school.Phone}</span>
                                                </span>
                                            ) : (
                                                <span className="text-muted small">-</span>
                                            )}
                                        </div>
                                    </td>
                                    <td className="text-center">
                                        <div className="d-flex flex-column align-items-center justify-content-center gap-1">
                                            {school.Country && (() => {
                                                const schoolCountryObj = countries.find((c) => c.value === school.Country);
                                                return (
                                                    <span className="small mt-1 d-flex align-items-center justify-content-center gap-1">
                                                        {schoolCountryObj && (
                                                            <LazyLoadImage
                                                                src={process.env.PUBLIC_URL + schoolCountryObj.icon}
                                                                alt={schoolCountryObj.name || schoolCountryObj.label}
                                                                className="mr-1 ml-0"
                                                                style={{
                                                                    width: "16px",
                                                                    height: "11px",
                                                                }}
                                                            />
                                                        )}
                                                        <span>
                                                            {schoolCountryObj?.name || school.Country}
                                                        </span>
                                                    </span>
                                                );
                                            })()}
                                            <span className="small text-muted">
                                                {t("Pages.Register.MaxTeacherCount.title")}:{" "}
                                                {school.MaxTeacherCount} |{" "}
                                                {t("Pages.Register.MaxStudentCount.title")}:{" "}
                                                {school.MaxStudentCount}
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            {/* Mobile Cards */}
            <div className="users-cards-list d-block d-md-none">
                {filterSchools.map((school) => {
                    const isQueuedForRemoval = toRemove && toRemove.includes(school.Id);
                    if (isQueuedForRemoval) return null;
                    return (
                        <div
                            key={school.Id}
                            className="user-card-modern shadow-sm border p-3 mb-3 bg-white"
                            style={{ borderRadius: "12px", cursor: "pointer" }}
                            onClick={() => onAction("info", school, t)}
                        >
                            <div className="d-flex align-items-center justify-content-between mb-2">
                                <div className="d-flex align-items-center">
                                    <LazyLoadImage
                                        src="/assets/images/logo/130p150.png"
                                        alt={school.Name}
                                        className="user-avatar-img ml-2"
                                        style={{ width: "40px", height: "40px" }}
                                    />
                                    <div>
                                        <div className="font-weight-bold text-dark">{school.Name}</div>
                                        <div className="text-muted small">#{school.Code}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="text-muted small mt-2">
                                <div>
                                    <i className="fal fa-envelope ml-1"></i> {school.Email || "-"}
                                </div>
                                <div>
                                    <i className="fal fa-phone ml-1"></i> {school.Phone || "-"}
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                    <i className="fal fa-globe ml-1"></i>{" "}
                                    {(() => {
                                        const schoolCountryObj = school.Country ? countries.find((c) => c.value === school.Country) : null;
                                        return (
                                            <>
                                                {schoolCountryObj && (
                                                    <LazyLoadImage
                                                        src={process.env.PUBLIC_URL + schoolCountryObj.icon}
                                                        alt={schoolCountryObj.name || schoolCountryObj.label}
                                                        className="mr-1 ml-0"
                                                        style={{
                                                            width: "16px",
                                                            height: "11px",
                                                        }}
                                                    />
                                                )}
                                                <span>
                                                    {schoolCountryObj?.name || school.Country || "-"}
                                                </span>
                                            </>
                                        );
                                    })()}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SchoolsTable;
